module.exports = __webpack_public_path__ + "img/Speaker=Jenn Henley.d9ff8784.png";